// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dial-popover .v-popper__inner{overflow:visible !important}`, "",{"version":3,"sources":["webpack://./src/components/UIShared/DialpadPanel.vue"],"names":[],"mappings":"AACA,+BACC,2BAAA","sourcesContent":["\n.dial-popover .v-popper__inner {\n\toverflow: visible !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
